import React, {useState, useEffect} from "react";
import {useIntl} from "react-intl";

import {Auth, AuthSlider} from "@housebets/housebets-x-package";
import {ForgotPassword, SignIn, SignUp} from "../Form";
import {Verification} from "../Form/Verification";

import {TPayload} from "../Form/SignUp/types";
import {LoginType} from "app/types/common";

import {setLoginType} from "app/store/slices/setting";
import {useAppSelector} from "hooks/useAppSelector";
import {authPromoSliderData} from "app/mock";
import {useDispatch} from "react-redux";

export const Wrapper: React.FC = () => {
    const {$t} = useIntl();
    const loginType = useAppSelector((state) => state.setting.loginType);
    const dispatch = useDispatch();

    const [activeTab, setActiveTab] = useState(loginType === LoginType.LOGIN ? 0 : 1);
    const [isShowVerification, setShowVerification] = useState(false);
    const [isShowVerificationButton, setShowVerificationButton] = useState(false);
    const [isShowPinPanel, setShowPinPanel] = useState(false);

    const [activeStep, setStep] = useState(0);
    const [isDisabledButton, setIsDisabledButton] = useState(true);

    useEffect(() => {
        setIsDisabledButton(true);
    }, [activeStep]);

    const [userData, setUserData] = useState<TPayload>({
        name: "",
        email: "",
        password: "",
        referral: "",
    });

    const handleNextstep = () => {
        setStep((prevStep: number) => prevStep + 1);
    };

    return (
        <Auth.Wrapper
            onClose={() => {
                dispatch(setLoginType(LoginType.HIDE));
                setTimeout(() => {
                    setActiveTab(0);
                    setShowVerification(false);
                    setShowPinPanel(false);
                }, 200);
            }}
            rightContent={<AuthSlider data={authPromoSliderData} />}>
            <Auth.StepsWrapper
                mobileTitle={activeTab === 0 ? $t({id: "LoginToAccount"}) : activeTab === 1 ? $t({id: "CreateAnAccount"}) : ""}
                activeTab={activeTab}
                isShowPinPanel={isShowPinPanel}
                isShowVerification={isShowVerification}
                onPrevClick={() => {
                    if (activeTab === 2) {
                        // forgot password
                        setActiveTab(0);
                    } else if (activeTab - 1 === 2) {
                        setActiveTab(2);
                        setShowPinPanel(false);
                        setShowVerificationButton(true);
                    } else if (activeTab - 1 === 1) {
                        setActiveTab(1);
                        setShowVerification(false);
                    } else {
                        setActiveTab((prev) => prev - 1);
                    }
                }}
                onCloseClick={() => {
                    dispatch(setLoginType(LoginType.HIDE));
                    setTimeout(() => {
                        setActiveTab(0);
                        setShowVerification(false);
                        setShowPinPanel(false);
                    }, 200);
                }}
                forgotPassword={
                    !isShowVerification ? (
                        <Auth.Form.ForgotPasswordWrapper activeStep={activeStep}>
                            <Auth.Form.Wrapper>
                                <ForgotPassword />
                            </Auth.Form.Wrapper>
                        </Auth.Form.ForgotPasswordWrapper>
                    ) : null
                }
                isForgotPassword={activeTab === 2}
                isShowBack={activeTab === 2}
                steps={
                    <Auth.Steps
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        tabs={[
                            {
                                tab: $t({id: "SignIn"}),
                                panel: (
                                    <SignIn
                                        onTabChange={setActiveTab}
                                        onSubmit={() => {
                                            dispatch(setLoginType(LoginType.HIDE));
                                        }}
                                    />
                                ),
                            },
                            {
                                tab: $t({id: "SignUp"}),
                                panel: (
                                    <SignUp
                                        onTabChange={setActiveTab}
                                        onSubmit={(data) => {
                                            setUserData(data);
                                            setShowVerification(true);
                                            setShowVerificationButton(true);
                                            setActiveTab((prev) => prev + 1);
                                        }}
                                    />
                                ),
                            },
                        ]}
                    />
                }
                verificationPanel={
                    <Verification
                        userData={userData}
                        isShowPinPanel={isShowPinPanel}
                        setActiveTab={setActiveTab}
                        setShowPinPanel={setShowPinPanel}
                        isShowVerificationButton={isShowVerificationButton}
                        setShowVerificationButton={setShowVerificationButton}
                    />
                }
            />
        </Auth.Wrapper>
    );
};

Wrapper.displayName = "Auth.Wrapper";
